export enum FormVersion {
  ONE_PAGE = 'one-page',
  SOCIAL_SIGN_UP = 'social-sign-up'
}
